import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  NEW_COUPON_LIST,
  NEW_COUPON_DELETE,
} from "../../../Constants/Config";

const initialState = {
  loading: false,
  ordercouponData: [],
  successMessage: "",
  error: "",
};

export const fetchOrderCouponList = createAsyncThunk(
  "OrderCouponList/fetchOrderCouponList.",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const response = await axios.post(BASE_URL + NEW_COUPON_LIST, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const deleteCoupon = createAsyncThunk(
  "OrderCouponList/deleteCoupon",
  async (data) => {
    try {
      const { token, ...dataNew } = data;

      const response = await axios.post(BASE_URL + NEW_COUPON_DELETE, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        return { couponId: data.coupon_id };
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

const ordercouponSlice = createSlice({
  name: "OrderCouponList",
  initialState,
  reducers: {
    updateStatus: (state, action) => {
      state.ordercouponData = Object.values(state.ordercouponData).map((coupon) => {
        if (coupon.id === action.payload.coupon_id) {
          return {
            ...coupon, // Spread syntax to copy existing properties
            is_disabled: action.payload.is_disabled, // Update the show_online
          };
        } 
        return coupon
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOrderCouponList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrderCouponList.fulfilled, (state, action) => {
      state.loading = false;
      state.ordercouponData = Array.isArray(action.payload)
        ? action.payload
        : Object.values(action.payload || {});
      state.error = "";
    });
    builder.addCase(fetchOrderCouponList.rejected, (state, action) => {
      state.loading = false;
      state.ordercouponData = [];
      state.error = action.error.message;
    });

    builder.addCase(deleteCoupon.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCoupon.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.ordercouponData = Object.values(state.ordercouponData).filter(
        (item) => item && item.id !== action.payload.couponId
      );
      state.error = ""; // Reset the error message
    });
    builder.addCase(deleteCoupon.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export const { updateStatus } = ordercouponSlice.actions;

export default ordercouponSlice.reducer;
